import React from 'react'
import PropTypes from 'prop-types'
import TabSwitch from './TabSwitch'
import useHasPermission, { Permissions } from 'hooks/useHasPermission'

const REAL_PLATFORMS = ['meta', 'google']
const ALL_PLATFORM_OPTIONS = ['all', ...REAL_PLATFORMS]

function useAvailablePlatforms() {
  const hasGoogleAccess = useHasPermission(Permissions.google)
  return hasGoogleAccess ? REAL_PLATFORMS : REAL_PLATFORMS.filter((platform) => platform !== 'google')
}

// For callers that render a divider or spacing next to the toggle and need to
// drop those along with it.
export function useHasMultiplePlatforms() {
  return useAvailablePlatforms().length > 1
}

const PlatformToggle = ({ platform, setPlatform, disabled = false, disabledTooltip = null, classNames = '', style = {} }) => {
  const availablePlatforms = useAvailablePlatforms()

  if (availablePlatforms.length < 2) return null

  return (
    <TabSwitch
      tabSwitch={platform}
      setTabSwitch={setPlatform}
      options={['all', ...availablePlatforms]}
      translationKey="Dashboard.platformToggle"
      disabled={disabled}
      disabledTooltip={disabledTooltip}
      classNames={classNames}
      style={style}
      size="small"
    />
  )
}

export default PlatformToggle

PlatformToggle.propTypes = {
  platform: PropTypes.oneOf(ALL_PLATFORM_OPTIONS).isRequired,
  setPlatform: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.string,
  classNames: PropTypes.string,
  style: PropTypes.object,
}
